import React from 'react';

const WeatherSensorView = ({ sensorStats }) => {
  if (!sensorStats) {
    return (
      <div className="text-center p-3">
        <i className="bi bi-question-circle text-muted me-2"></i>
        Nessun dato disponibile
      </div>
    );
  }
  
  // Helper per la direzione del vento
  const getWindDirectionText = (degrees) => {
    if (degrees === null || degrees === undefined) return 'N/A';
    
    const directions = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];
    const index = Math.round(degrees / 22.5) % 16;
    return directions[index];
  };

  // Helper per verificare se un valore è valido
  const isValidNumber = (value) => {
    return value !== null && value !== undefined && !isNaN(parseFloat(value));
  };
  
  // Helper per formattare numeri in modo sicuro
  const safeToFixed = (value, decimals = 1) => {
    if (!isValidNumber(value)) return 'N/A';
    return parseFloat(value).toFixed(decimals);
  };
  
  return (
    <div>
      <div className="row g-2 mb-3">
        {/* Temperatura */}
        <div className="col-6">
          <div className="bg-light p-2 rounded h-100">
            <div className="d-flex justify-content-between">
              <h4 className="small fw-semibold text-muted mb-0">Temperatura</h4>
              <span className="badge bg-secondary text-white small">
                {sensorStats.lastUpdateTime ? new Date(sensorStats.lastUpdateTime).toLocaleTimeString('it-IT', {hour: '2-digit', minute:'2-digit'}) : 'N/A'}
              </span>
            </div>
            <div className="fs-1 fw-bold text-danger lh-1 my-1">
              {safeToFixed(sensorStats.currentTemp)}°
            </div>
            <div className="small text-muted lh-sm">
              <div className="d-flex justify-content-between">
                <span>Min: {safeToFixed(sensorStats.tempMin)}° <small>({sensorStats.tempMinTime})</small></span>
                <span>Max: {safeToFixed(sensorStats.tempMax)}° <small>({sensorStats.tempMaxTime})</small></span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Umidità */}
        <div className="col-6">
          <div className="bg-light p-2 rounded h-100">
            <div className="d-flex justify-content-between">
              <h4 className="small fw-semibold text-muted mb-0">Umidità</h4>
              <span className="badge bg-secondary text-white small">
                {sensorStats.lastUpdateTime ? new Date(sensorStats.lastUpdateTime).toLocaleTimeString('it-IT', {hour: '2-digit', minute:'2-digit'}) : 'N/A'}
              </span>
            </div>
            <div className="fs-1 fw-bold text-primary lh-1 my-1">
              {safeToFixed(sensorStats.currentUmid, 0)}%
            </div>
            <div className="small text-muted lh-sm">
              <div className="d-flex justify-content-between">
                <span>Min: {safeToFixed(sensorStats.umidMin, 0)}% <small>({sensorStats.umidMinTime})</small></span>
                <span>Max: {safeToFixed(sensorStats.umidMax, 0)}% <small>({sensorStats.umidMaxTime})</small></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Dati meteo aggiuntivi */}
      <div className="row g-2 mb-3">
        {/* Pressione */}
        <div className="col-4">
          <div className="bg-light p-2 rounded h-100">
            <h4 className="small fw-semibold text-muted mb-0">Pressione</h4>
            <div className="fs-3 fw-bold text-secondary">
              {safeToFixed(sensorStats.pressure, 0)} hPa
            </div>
          </div>
        </div>
        
        {/* Vento */}
        <div className="col-4">
          <div className="bg-light p-2 rounded h-100">
            <h4 className="small fw-semibold text-muted mb-0">Vento</h4>
            <div className="fs-3 fw-bold text-success">
              {safeToFixed(sensorStats.windSpeed)} km/h
            </div>
            <div className="small text-muted">
              {getWindDirectionText(sensorStats.windDirection)}
            </div>
          </div>
        </div>
        
        {/* UV */}
        <div className="col-4">
          <div className="bg-light p-2 rounded h-100">
            <h4 className="small fw-semibold text-muted mb-0">Indice UV</h4>
            <div className="fs-3 fw-bold text-warning">
              {safeToFixed(sensorStats.uvIndex)}
            </div>
          </div>
        </div>
      </div>

      {/* Riga aggiuntiva per intensità luminosa e pioggia */}
      <div className="row g-2 mb-3">
        {/* Intensità luminosa */}
        <div className="col-6">
          <div className="bg-light p-2 rounded h-100">
            <h4 className="small fw-semibold text-muted mb-0">Intensità luminosa</h4>
            <div className="fs-3 fw-bold text-warning">
              {isValidNumber(sensorStats.lightIntensity) ? 
                `${parseInt(sensorStats.lightIntensity)} lux` : 'N/A'}
            </div>
          </div>
        </div>
        
        {/* Pioggia */}
        <div className="col-6">
          <div className="bg-light p-2 rounded h-100">
            <h4 className="small fw-semibold text-muted mb-0">Pioggia</h4>
            <div className="fs-3 fw-bold text-info">
              {isValidNumber(sensorStats.rainGauge) ? 
                `${safeToFixed(sensorStats.rainGauge, 1)} mm` : '0.0 mm'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeatherSensorView;